import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {CollectionItemType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemType'
import {IResourceItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceItemResponseInstance'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {ResourceTypeIconMap} from '@toolify/client/src/modules/resources/maps/ResourceTypeIconMap'
import {getCollectionFolderPayload} from '@toolify/client/src/modules/collections/functions/getCollectionFolderPayload'
import {getCollectionLinkPayload} from '@toolify/client/src/modules/collections/functions/getCollectionLinkPayload'
import {getCollectionResourcePayload} from '@toolify/client/src/modules/collections/functions/getCollectionResourcePayload'
import {findCollectionResourceItem} from '@toolify/client/src/modules/collections/functions/findCollectionResourceItem'

export function getCollectionItemIconNameType(
  item: ICollectionItemResponseInstance,
  resourceItems: IResourceItemResponseInstance[] = [],
): IconNameType {
  if(item.collectionItemType === CollectionItemType.Folder) {
    return getCollectionFolderPayload(item)?.iconNameType || IconNameType.FolderClosed
  }
  if(item.collectionItemType === CollectionItemType.Link) {
    return getCollectionLinkPayload(item)?.iconNameType || IconNameType.Link
  }
  const payload = getCollectionResourcePayload(item)
  const resourceItem = findCollectionResourceItem(item, resourceItems)
  if(resourceItem?.iconNameType) {
    return resourceItem.iconNameType
  }
  return (payload?.resourceType && ResourceTypeIconMap.get(payload.resourceType)) || IconNameType.LayerGroup
}
